import { signal } from "@preact/signals-react"

export const utgManifestLoadedSignal = signal(false)
export const utgManifestErrorSignal = signal(null)
export const utgManifestSignal = signal([])